export default function Hero() {
  return (
    <section
      className="relative isolate -z-10 overflow-hidden bg-gradient-to-b from-indigo-100/20 pt-32"
      style={{
        backgroundImage: "url('/fondo.JPG')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        aria-hidden="true"
        className="absolute inset-y-0 right-1/2 -z-10 -mr-96 w-[200%] origin-top-right skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 sm:-mr-80 lg:-mr-96"
      />

      <div className="mx-auto max-w-7xl px-6 py-32 sm:py-40 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">

          <h1 className="max-w-2xl text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
            En Despega hacemos que viajar sea más fácil, seguro y emocionante.
          </h1>

          <p className="mt-6 max-w-xl text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
            Conectamos personas con destinos increíbles, experiencias únicas
            y precios accesibles para que tu próxima aventura empiece sin complicaciones.
          </p>

        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32" />
    </section>
  );
}
